import React from 'react';
import PropTypes from 'prop-types';

const ImageFigure = ({ src, className, key, alt, description, ariaLabel }) => {
  return typeof src === 'string' ? (
    <figure className={className || null} key={key || null}>
      <img src={src} alt={alt || null} aria-label={ariaLabel} />
      {description ? <figcaption>{description}</figcaption> : null}
    </figure>
  ) : null;
};

export default ImageFigure;

ImageFigure.propTypes = {
  src: PropTypes.string.isRequired,
  className: PropTypes.string,
  key: PropTypes.string,
  alt: PropTypes.string.isRequired,
  description: PropTypes.string,
};
ImageFigure.defaultProps = {
  className: null,
  description: null,
  key: null,
};
